export const PARTNER_CATEGORIES = [
  'Gastronomia',
  'Beleza & Estética',
  'Saúde & Bem-estar',
  'Moda & Acessórios',
  'Educação',
  'Entretenimento',
  'Tecnologia',
  'Serviços',
  'Esporte & Fitness',
  'Casa & Decoração',
  'Viagem & Turismo',
  'Outros',
] as const;

export const PARTNER_FILTER_CATEGORIES = ['Todos', ...PARTNER_CATEGORIES] as const;

type OfficialPartnerCategory = (typeof PARTNER_CATEGORIES)[number];

const normalizeCategoryKey = (value?: string | null) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' e ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');

const CATEGORY_ALIAS_MAP: Record<string, OfficialPartnerCategory> = {
  gastronomia: 'Gastronomia',
  alimentacao: 'Gastronomia',
  restaurante: 'Gastronomia',
  restaurantes: 'Gastronomia',
  comida: 'Gastronomia',
  food: 'Gastronomia',
  hamburgueria: 'Gastronomia',
  sushi: 'Gastronomia',
  lanches: 'Gastronomia',

  beleza: 'Beleza & Estética',
  estetica: 'Beleza & Estética',
  makes: 'Beleza & Estética',
  maquiagem: 'Beleza & Estética',
  'maquiagem profissional': 'Beleza & Estética',
  lash: 'Beleza & Estética',
  nails: 'Beleza & Estética',
  bronzeamento: 'Beleza & Estética',
  bronzeamentos: 'Beleza & Estética',

  saude: 'Saúde & Bem-estar',
  'bem estar': 'Saúde & Bem-estar',
  'bem estar saude': 'Saúde & Bem-estar',
  'bem estar e saude': 'Saúde & Bem-estar',
  odontologia: 'Saúde & Bem-estar',
  'clinica odontologica': 'Saúde & Bem-estar',
  harmonizacao: 'Saúde & Bem-estar',

  moda: 'Moda & Acessórios',
  acessorios: 'Moda & Acessórios',
  vestuario: 'Moda & Acessórios',
  roupas: 'Moda & Acessórios',
  semijoias: 'Moda & Acessórios',
  joias: 'Moda & Acessórios',
  calcados: 'Moda & Acessórios',

  educacao: 'Educação',
  ensino: 'Educação',
  cursos: 'Educação',
  'pre vestibular': 'Educação',
  'pre vestibulares': 'Educação',

  eventos: 'Entretenimento',
  entretenimento: 'Entretenimento',
  festa: 'Entretenimento',
  festas: 'Entretenimento',
  bar: 'Entretenimento',
  bares: 'Entretenimento',

  tecnologia: 'Tecnologia',
  tech: 'Tecnologia',

  servicos: 'Serviços',
  servico: 'Serviços',

  esporte: 'Esporte & Fitness',
  fitness: 'Esporte & Fitness',
  academia: 'Esporte & Fitness',

  casa: 'Casa & Decoração',
  decoracao: 'Casa & Decoração',
  'casa decoracao': 'Casa & Decoração',

  viagem: 'Viagem & Turismo',
  turismo: 'Viagem & Turismo',
  'passagens aereas': 'Viagem & Turismo',
  viagens: 'Viagem & Turismo',

  outros: 'Outros',
};

export const normalizePartnerCategory = (value?: string | null): OfficialPartnerCategory => {
  const normalizedKey = normalizeCategoryKey(value);
  if (!normalizedKey) return 'Outros';

  const directOfficialMatch = PARTNER_CATEGORIES.find(
    (category) => normalizeCategoryKey(category) === normalizedKey,
  );
  if (directOfficialMatch) return directOfficialMatch;

  return CATEGORY_ALIAS_MAP[normalizedKey] || 'Outros';
};

export const isOfficialPartnerCategory = (value?: string | null) =>
  PARTNER_CATEGORIES.includes(normalizePartnerCategory(value));
